module.exports = "/templates/viewreports.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/viewreports.html
// module id = 486
// module chunks = 0